<template>
<div class="ti">
  <div>
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    <!-- <el-button type="success text2" style="margin-left: 1px;" @click="getXscs">拉取新视窗项目表</el-button> -->
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getXsc">拉取项目房产</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;color: #000;" @click="getRegion">根据新视窗区域划分(拉账单前先分区域)</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getCharge">拉取项目收费项</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getChargeitem">拉取费用分类</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getDeposit">拉取项目押金</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getAdvance">拉取项目预收款</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getRoom">拉取项目房间收费设置</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getDiscountDetail">拉取费用减免明细</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="onGetUserBase">拉取客户基础信息</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="onGetUserInfo">拉取客户详情信息</el-button>
    <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="getOrderModifyDetail">拉取项目应收款变动明细</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">拉取项目名称</th>
            <th class="text-left">状态</th>
            <th class="text-left">房产数</th>
            <th class="text-left">车位数</th>
            <th class="text-left">储藏室数</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td ><span v-if="item.static == 1">拉取成功</span>
            <span v-if="item.static == 2">导入成功</span>
            <span v-if="item.static == 3">拒绝导入</span>
            <span v-if="item.static == 5">拉取账单进度：{{item.s_billInt}}/{{item.e_billInt}}</span>
            <span v-if="item.static == 6">拉取账单完成，数量：{{item.e_billInt}}</span>
            </td>
            <td >{{item.count1}}</td>
            <td >{{item.count2}}</td>
            <td >{{item.count3}}</td>
            <td >{{item.s_date}}</td>
            <td >
                <Button type="info" shape="circle" @click="xhazai(item.route)">下载</Button>
                <Button type="primary" shape="circle" @click="adopt(item.id)" v-if="item.static != 2 && item.static != 3 && item.static <5">导入</Button>
                <Button type="error" shape="circle" @click="refuse(item.id)" v-if="item.static != 2 && item.static != 3 && item.static <5">拒绝</Button>
                <Button type="primary" shape="circle" v-if="item.static == 2 && item.static != 3" @click="bill(item.id)">拉取账单</Button>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>

    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="拉取新视窗项目房产"
        @on-ok="ok">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">
              <el-select v-model="xscPindexId" filterable placeholder="选择拉取的新视窗项目表项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
    <Modal
        v-model="modal12"
        ok-text="确定"
        width="460"
        title="选择项目"
        @on-ok="adopts">
         <el-select  v-model="data.pid" filterable placeholder="选择项目">
          <el-option
            v-for="item in types"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
    </Modal>

    <Modal
        v-model="charge"
        ok-text="拉取"
        width="800"
        title="拉取新视窗收费项"
        @on-ok="okCharge">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">
              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目表项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

    <Modal
        v-model="deposit"
        ok-text="拉取"
        width="800"
        title="拉取新视窗押金"
        @on-ok="okDeposit">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">
              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
    <Modal
        v-model="advance"
        ok-text="拉取"
        width="800"
        title="拉取新视窗预收款"
        @on-ok="okAdvance">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">
              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

    <Modal
        v-model="region"
        ok-text="区域划分"
        width="800"
        title="根据新视窗房产进行区域划分"
        @on-ok="okRegion">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">
              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

    <Modal
        v-model="room"
        ok-text="拉取"
        width="800"
        title="拉取项目房间收费设置"
        @on-ok="okRoom">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">

              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

    <Modal
        v-model="discountDetail"
        ok-text="拉取"
        width="800"
        title="拉取费用减免明细"
        @on-ok="okDiscountDetail">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">

              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

  <Modal
    v-model="discountDetail_1"
    ok-text="拉取"
    width="800"
    title="拉取客户基础信息"
    @on-ok="getUserBase">
    <div style="height: 600px;">
      <el-form  label-width="80px">
        <el-form-item label="选择项目" :rules="[{required: true}]">

          <el-select v-model="houseid_1" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
            <el-option
              v-for="item in xscPindex"
              :key="item.id"
              :label="item.PrecinctShortName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </Modal>

  <Modal
    v-model="discountDetail_2"
    ok-text="拉取"
    width="800"
    title="拉取客户详细信息"
    :loading="true"
    @on-ok="getUserInfo(0)">
    <div style="height: 600px;">
      <el-form  label-width="80px">
        <el-form-item label="选择项目" :rules="[{required: true}]">
          <el-select v-model="houseid_2" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
            <el-option
              v-for="item in xscPindex"
              :key="item.id"
              :label="item.PrecinctShortName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="进度">
          <el-progress :percentage="math_floor((userInfoProgress.p/userInfoProgress.count)*100)"></el-progress>
        </el-form-item>
        <el-form-item label="耗时">
          {{userInfoProgress.time}} s
        </el-form-item>
      </el-form>
    </div>
  </Modal>

  <Modal
        v-model="orderModifyDetail"
        ok-text="拉取"
        width="800"
        title="拉取应收款变动明细"
        @on-ok="okOrderModifyDetail">
        <div style="height: 600px;">
          <el-form  label-width="80px">
            <el-form-item label="选择项目" :rules="[{required: true}]">

              <el-select v-model="houseid" filterable placeholder="选择拉取的新视窗项目" style="width:600px">
                <el-option
                  v-for="item in xscPindex"
                  :key="item.id"
                  :label="item.PrecinctShortName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>

</div>

</template>

<script>
export default {
  name: 'xsc',
  data () {
    return {
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      options2:[],
      value: '',
      xscPindexId:'',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'拉取项目',
      modal1: false,
      loading:false,
      modal12:false,
      charge:false,
      deposit:false,
      advance:false,
      region:false,
      room:false,
      discountDetail: false,
      orderModifyDetail: false,
      data:{
        pid:'',
        xscid:'',
      },
      types:[],
      xscPindex:[],
      houseid:'',
      discountDetail_1:false,
      houseid_1:"",
      discountDetail_2:false,
      houseid_2:"",
      userInfoProgress:{count:100,p:0,time:0},
      math_floor:Math.floor
    }
  },
  //界面没出来前加载
  created() {

  },
  // 加载数据
  mounted(){
    ERP.showLoading()
    this.$Loading.start();
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('xsc/getXsc?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.xscPindex = backdata.data[3];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //房间收费设置
    getRoom(){
      this.room = true;
    },
    okRoom(){
      ERP.showLoading()
      this.$myhttp.post('xsc/room',{'dbid':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        ERP.hideLoading()
        if(backdata.data.code == 201){
          this.$Message.error(backdata.data.message);
        }else{
          this.$Message.success('拉取成功!');
        }
      })
    },
    //区域划分
    getRegion(){
      this.region = true;
    },
    okRegion(){
      ERP.showLoading()
      this.$myhttp.post('xsc/region',{'dbid':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        ERP.hideLoading()
        if(backdata.data.code == 201){
          this.$Message.error(backdata.data.message);
        }else{
          this.$Message.success('操作成功!');
        }
      })
    },
    //拉取预收款
    getAdvance(){
      this.advance = true;
    },
    okAdvance(){
      ERP.showLoading()
      this.$myhttp.post('xsc/advance',{'dbid':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        ERP.hideLoading()
        if(backdata.data.code == 201){
          this.$Message.error(backdata.data.message);
        }else{
          this.$Message.success('拉取成功!');
        }
      })
    },
    //拉取押金
    getDeposit(){
      this.deposit = true;
    },
    okDeposit(){
      ERP.showLoading()
      this.$myhttp.post('xsc/deposit',{'dbid':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        ERP.hideLoading()
        if(backdata.data.code == 201){
          this.$Message.error(backdata.data.message);
        }else{
          this.$Message.success('拉取成功!');
        }
      })
    },

    //拉取新视窗收费项
    getCharge(){
      this.charge = true;
    },
    okCharge(){
      //console.log(this.houseid);
      this.charge = false;
      this.$myhttp.post('project/getCharge',{'dbid':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.$Message.success('拉取成功!');
      })
    },
    //拉取新视窗账单
    bill(id){
      var data = {'id':id};
      this.$myhttp.post('xsc/timePost',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
            if(backdata.data.code == 200){
              var t = Date.parse(new Date()) / 1000;//时间戳
              this.$myhttp.get('xsc/getXsc?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                  this.desserts = backdata.data[0];
                  this.total = backdata.data[1];
                  this.page = backdata.data[2];
                  this.loading = false;
              });
            }
        })
    },
    //新视窗拉取项目
    getXsc(){
        this.modal1 = true;
    },
    //拉取新视窗项目
    ok(){
        var data = {'xscPindexId':this.xscPindexId};
        this.loading = true;
        this.$myhttp.post('xsc/index',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
            if(backdata.data.code == 200){
              var t = Date.parse(new Date()) / 1000;//时间戳
              this.$myhttp.get('xsc/getXsc?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                  this.desserts = backdata.data[0];
                  this.total = backdata.data[1];
                  this.page = backdata.data[2];
                  this.loading = false;
              });
            }
        })
    },
    //拉新视窗项目表
    getXscs(){
      this.$confirm('确定要拉取新视窗项目表吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$myhttp.post('xsc/pullPindex',{},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 200){
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('xsc/getXsc?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
                'Content-Type': 'application/json'
                }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.loading = false;
                    this.$Message.success('拉取成功!');
                });
              }
          });
        }).catch(() => {
          this.loading = false;
        });
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('xsc/getXsc?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('xsc/getXsc?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //下载文件审核
    xhazai(e){
      var url = this.$myhttp.defaults.baseURL+"/"+e;
      window.open(url)
    },
    //拒接
    refuse(e){
      var id = {'id':e};
      this.loading = true;
      this.$myhttp.post('xsc/xscExcelRefuse',id,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.$myhttp.get('xsc/getXsc?id=1'+'&company='+this.value +'&company1='+this.value1+"&distinguish=0",{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
                this.loading=false;
            });
             this.$Message.success('操作成功!');
      });
    },
    //导入
    adopt(e){
      this.data.xscid = e;
      var value = '';
      var value1 = '';
      var t = '';
      this.$Loading.start();
      this.$myhttp.get('xsc/getPindex?id=1'+'&company='+value+'&company1='+value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.types = backdata.data[0];
            this.$Loading.finish();
        });
      this.modal12 = true;
    },
    adopts(){
      if(this.data.pid == ""){
        this.$Message.error('项目不能为空!');
        return false;
      }
      var data = this.data;
      this.loading = true;
      this.$myhttp.post('xsc/xscAdopt',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loading = false;
          this.$Message.success('导入成功!');
          this.searchs();
      });
    },
    //拉取费用分类
    getChargeitem(){
      this.$confirm('确定要拉取新视窗的费用分类吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.loading = false;
          this.$myhttp.post('project/getChargeitems',{},{
              'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{
             this.$Message.success('拉取成功!');
          })

        }).catch(() => {
          this.loading = false;
        });
    },
    getDiscountDetail() {
      this.discountDetail = true
    },
    okDiscountDetail() {
      this.discountDetail = false;
      this.$myhttp.post('xsc/getDiscountDetail',{'xscPindexId':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code != 200) {
          this.$Message.error(backdata.data.message);
        }else {
          this.$Message.success('拉取成功!');
        }
      })
    },
    onGetUserBase(){
      this.discountDetail_1 = true;
    },
    onGetUserInfo(){
      var that=this;
      that.$confirm('请确定先拉取了客户基础信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.discountDetail_2 = true;
      }).catch(() => {
        that.discountDetail_2 = false;
      });
    },
    getUserBase() {
      ERP.postRequest({url:'xsc/Customer/getUserBase',data:{'id':this.houseid_1}},res=>{
        if(res.code) {
          this.$Message.success(res.msg||'拉取成功!');
          this.discountDetail_1 = false;
        }else {
          this.$Message.error(res.msg);
        }
      })
    },
    getUserInfo(p=0) {
      var that=this;
      ERP.postRequest({url:'xsc/Customer/getUserInfo',data:{'id':this.houseid_2,p:p}},res=>{
        if(res.code) {
          that.$Message.success((res.msg||'拉取成功!')+"耗时："+res.time);
          let time=that.userInfoProgress.time;
          that.userInfoProgress=res.data;
          that.userInfoProgress.time=time+(res.time*1);
          if(res.data.p<(res.data.count-1)){
            p=p+1;
            that.getUserInfo(p);
          }else {
            that.discountDetail_2=false;
          }
        }else {
          that.$Message.error(res.msg);
        }
      })
    },
    getOrderModifyDetail() {
      this.orderModifyDetail = true
    },
    okOrderModifyDetail() {
      this.orderModifyDetail = false;
      this.$myhttp.post('xsc/addOrderModifyDetailTask',{'xscPindexId':this.houseid},{
          'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code != 200) {
          this.$Message.error(backdata.data.message);
        }else {
          this.$Message.success('拉取成功!');
        }
      })
    },
  },
  watch: {
    // '$route' (to, from) { //监听路由是否变化
    //   if(to.path == "/pindex/Examine"){
    //    //加载项目列表
    //     this.$Loading.start();
    //     this.$myhttp.get('admin/examine?id=1'+'&company='+this.value +'&company1='+this.value1+"&distinguish=0",{
    //       'Content-Type': 'application/json'
    //       }).then(backdata=>{ // 异步执行成功后
    //         this.desserts = backdata.data[0];
    //         this.total = backdata.data[1];
    //         this.page = backdata.data[2];
    //         this.$Loading.finish();
    //     });
    //   }
    // }
  },

}
</script>
<style scoped>
.texts{
    color: rgb(240, 236, 236);
}
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.el-button{
    color: rgb(252, 247, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/xsc/xsc.vue